(() => {
  const resultSelector = [
    'page-header .main-search .main-search__results',
    'page-header .main-search .main-search__results_conteiner'
  ].join(', ');

  function keepResultClicksInsideSearch(event) {
    const target = event.target;
    if (target?.closest?.('a.product-link, a.main-search__results-all-link, .block-inner-inner')) {
      // The search component is rendered inside its trigger link. Prevent the
      // click from bubbling back to the trigger after result handlers run.
      event.stopPropagation();
    }
  }

  function initialize() {
    document.querySelectorAll(resultSelector).forEach((container) => {
      if (container.dataset.searchClickBoundary === 'true') return;
      container.dataset.searchClickBoundary = 'true';
      container.addEventListener('click', keepResultClicksInsideSearch);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
